import React from 'react';
import { View, Text, StyleSheet, ScrollView, StyleProp, ViewStyle } from 'react-native';

export interface PrivacyPolicyBodyProps {
  t: (key: string) => string;
  style?: StyleProp<ViewStyle>;
  contentContainerStyle?: StyleProp<ViewStyle>;
}

const PrivacyPolicyBody: React.FC<PrivacyPolicyBodyProps> = ({ t, style, contentContainerStyle }) => {
  return (
    <ScrollView 
      style={[styles.content, style]}
      contentContainerStyle={[styles.scrollContent, contentContainerStyle]}
      showsVerticalScrollIndicator={false}
    >
      <Text style={styles.sectionTitle}>{t('privacyPolicyScreen.dataCollection')}</Text>
      <Text style={styles.policyText}>
        {t('privacyPolicyScreen.dataCollectionContent')}
      </Text>

      <Text style={styles.sectionTitle}>{t('privacyPolicyScreen.informationUse')}</Text>
      <Text style={styles.policyText}>
        {t('privacyPolicyScreen.informationUseContent')}
      </Text>

      <Text style={styles.sectionTitle}>{t('privacyPolicyScreen.dataSecurity')}</Text>
      <Text style={styles.policyText}>
        {t('privacyPolicyScreen.dataSecurityContent')}
      </Text>

      <Text style={styles.sectionTitle}>{t('privacyPolicyScreen.userRights')}</Text>
      <Text style={styles.policyText}>
        {t('privacyPolicyScreen.userRightsContent')}
      </Text>

      <Text style={styles.sectionTitle}>{t('privacyPolicyScreen.contactUs')}</Text>
      <Text style={styles.policyText}>
        {t('privacyPolicyScreen.contactUsContent')}
      </Text>

      <Text style={styles.updateInfo}>
        {t('privacyPolicyScreen.lastUpdated')}
      </Text>
    </ScrollView>
  );
};

const styles = StyleSheet.create({
  content: {
    flex: 1,
  },
  scrollContent: {
    padding: 16,
    paddingBottom: 32,
  },
  sectionTitle: {
    fontSize: 18,
    fontWeight: '600',
    color: '#333',
    marginTop: 24,
    marginBottom: 12,
  },
  policyText: {
    fontSize: 14,
    color: '#666',
    lineHeight: 22,
    marginBottom: 16,
  },
  updateInfo: {
    fontSize: 12,
    color: '#999',
    textAlign: 'center',
    marginTop: 32,
    fontStyle: 'italic',
  },
});

export default PrivacyPolicyBody;
